import React from 'react';
import { Button } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { getModuloMateriales, ModuloMaterialDescarga } from '../../config/moduloMateriales';

interface ModuloMaterialDescargasProps {
  campo: string;
}

function dispararDescarga(material: ModuloMaterialDescarga) {
  const enlace = document.createElement('a');
  enlace.href = material.href;
  enlace.download = material.fileName;
  enlace.rel = 'noopener';
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
}

/** Un clic baja todos los archivos del módulo. El intervalo evita que el navegador cancele la segunda descarga. */
function descargarDocumentacion(materiales: ModuloMaterialDescarga[]) {
  materiales.forEach((material, index) => {
    window.setTimeout(() => dispararDescarga(material), index * 400);
  });
}

const ModuloMaterialDescargas: React.FC<ModuloMaterialDescargasProps> = ({ campo }) => {
  const materiales = getModuloMateriales(campo);
  if (materiales.length === 0) return null;

  return (
    <Button
      type="button"
      size="small"
      variant="outlined"
      startIcon={<DescriptionOutlinedIcon />}
      sx={{ textTransform: 'none' }}
      onClick={() => descargarDocumentacion(materiales)}
    >
      Documentación
    </Button>
  );
};

export default ModuloMaterialDescargas;
